import React, { FC } from 'react';
import { Box, Text } from '@bechtel/gds';
import { AvatarRegularStyled } from './styled';
import { useName, PersonaMessages } from '@bechtel/client-common';
import { useLingui } from '@lingui/react';
import { UserInfoProps } from './types';

export const UserInfo: FC<UserInfoProps> = ({ crewMember, showBadgeNumber }) => {
  const { getFullName } = useName();
  const { i18n } = useLingui();
  return (
    <Box alignItems={{ sm: 'center' }}>
      <Box pr={{ sm: '300' }}>
        <AvatarRegularStyled
          hasImageUrl={crewMember && crewMember.imageUrl ? true : false}
          src={crewMember && crewMember.imageUrl ? crewMember.imageUrl : undefined}
        />
      </Box>
      <Box flexDirection={{ sm: 'column' }}>
        <Text size="300" weight="600" data-testid="crew-name">
          {getFullName(crewMember.firstName, crewMember.lastName)}
        </Text>
        {showBadgeNumber ? (
          <Text size="250" color="grey.600" data-testid="crew-badge-no">
            {crewMember.badgeNumber}
          </Text>
        ) : (
          <Text size="300" color="grey.600" style={{ marginTop: '4px' }} data-testid="crew-persona">
            {crewMember && crewMember.persona && i18n._(PersonaMessages[crewMember.persona])}
          </Text>
        )}
      </Box>
    </Box>
  );
};